export const BACKSPACE_KEY_CODE = 8
export const TAB_KEY = 9
export const ENTER_KEY_CODE = 13
export const DOT_KEY_CODES = [190, 110]
export const CONTROL_KEY_CODE = 17
export const ESCAPE_KEY_CODE = 27
export const SPACE_BAR_KEY_CODE = 32
export const LEFT_ARROW_KEY_CODE = 37
export const UP_ARROW_KEY = 38
export const RIGHT_ARROW_KEY_CODE = 39
export const DOWN_ARROW_KEY = 40
export const DELETE_KEY_CODE = 46
export const Z_KEY = 90
export const E_KEY_CODE = 69
export const NEW_LINE_CHAR = '\n'

export const ENTER_KEY_VALUE = 'Enter'
export const BACkSPACE_KEY_VALUE = 'Backspace'
export const DELETE_KEY_VALUE = 'Delete'
export const LEFT_ARROW_KEY_VALUE = 'ArrowLeft'
export const RIGHT_ARROW_KEY_VALUE = 'ArrowRight'
export const SPACE_BAR_KEY_VALUE = 'Spacebar'
export const SPACE_KEY_VALUE = 'Space'
export const SPACE_SYMBOL_KEY_VALUE = ' '
export const ESCAPE_KEY_VALUE = 'Escape'
export const E_KEY_VALUE = 'e'

export const SHIFT_KEY_VALUE = 'Shift'

export const DOT_KEY_VALUE = '.'
